import Vue from 'vue'
import router from '@/router'
import store from '@/store'

function getMenuActiveName() {
   return store.state.common.menuActiveName;
}

function setMenuActiveName(val) {
  store.commit('common/updateMenuActiveName', val)
}

function getMainTabs() {
   return store.state.common.mainTabs;
}

function setMainTabs(val) {
  store.commit('common/updateMainTabs', val)
}

function getMainTabsActiveName() {
   return store.state.common.mainTabsActiveName;
}

function setMainTabsActiveName(val) {
  store.commit('common/updateMainTabsActiveName', val)
}


// tabs, 选中tab
export function selectedTabHandle(tab) {
  tab = getMainTabs().filter(item => item.name === tab.name)
  if (tab.length >= 1) {
    goToTab(tab[0])
  }
}

export function goToTab(tabItem,fn) {
  let routeName = tabItem.routeName || tabItem.name
  let params = tabItem.params || {}
  let query = tabItem.query || {}
  if(fn) {
    router.push({name: routeName, params: params,query: query},fn)
  }else{
    router.push({name: routeName, params: params,query: query})
  }
}

// tabs, 删除tab
export function removeTabHandle(tabName) {
  let mainTabs = getMainTabs().filter(item => item.name !== tabName)
  setMainTabs(mainTabs)
  if (mainTabs.length >= 1) {
    // 当前选中tab被删除
    if (tabName === getMainTabsActiveName()) {
      let newTab=mainTabs[mainTabs.length - 1]
      let newTabName = newTab.name
      goToTab(newTab,()=>{
        setMainTabsActiveName(newTabName)
      })
    }
  } else {
    setMenuActiveName('')
    router.push({name: 'home'})
  }
}

// tabs, 关闭当前
export function tabsCloseCurrentHandle() {
  removeTabHandle(getMainTabsActiveName())
}
// tabs, 关闭其它
export function tabsCloseOtherHandle() {
  let mainTabs = getMainTabs().filter(item => item.name === getMainTabsActiveName())
  setMainTabs(mainTabs)
}
// tabs, 关闭全部
export function tabsCloseAllHandle() {
  setMainTabs([])
  setMenuActiveName('')
  router.push({name: 'home'})
}

// tabs, 刷新当前
export function tabsRefreshCurrentHandle() {
  var tempTabName = getMainTabsActiveName();
  let  tab = getMainTabs().filter(item => item.name === tempTabName);
  let currentTab = null;
  if (tab.length >= 1) {
    currentTab = JSON.parse(JSON.stringify(tab[0]))
  }
  removeTabHandle(tempTabName)
  Vue.nextTick(() => {
    router.push({name: tempTabName,query:currentTab.query || {},params:currentTab.params ||{}})
  })
}
